import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const BrochurePopup = ({buttonClass, buttonText, iconSrc, flag}) => {


    const [show, setShow] = useState(false);


    const handleModal = () => {
        setShow(!show)
        setTimeout(() => {
            // Refresh selectpicker after modal is rendered
            window.$('.header-state-selectpicker').selectpicker('refresh');
            window.$('.header-fleet-selectpicker').selectpicker('refresh');
        }, 0);
    }


    const handleClose = () => {
        setShow(false)
    }



  return (
    <div>
        <button className={buttonClass} onClick={handleModal} style={{ cursor: "pointer" }}>
        {buttonText} {iconSrc && <img src={iconSrc} alt="Join Waitlist icon" />}
        </button>

        {/* modal body */}
        <Modal id="waitlist" className='joinlist'  show={show} onHide={handleClose} centered>

       <div className='brochure-modal'>

            <Modal.Header closeButton>
                <Modal.Title>View are 2025 brochure</Modal.Title>
            </Modal.Header>

                <div className='brochure-cont'>
                   
                   <div className='brochure-head'>
                    <h2>rentid</h2>
                    <img src='img/scan.jpg' alt="scaner"/>
                   </div>

                   <div className="brochure-pro">
                   
                   <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12'>
                        <h2>Rental Products</h2>
                        <p>The only modular rental ecosystem built for performance</p>
                    </div>
                   </div>

                   <div className='row justify-content-center'>
                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                        <div className='broc-product-boc'>
                        <figure><img className="img-fluid" src="/img/direct.svg" alt="blog" /><h4><span>rent</span>direct</h4></figure>
                        <div className='broc-product-text'>
                        <h3>Smart Booking Management</h3>
                        <p>All-in-one booking system connected to a suite of rental workflows & tools unlike any other.</p>
                        </div>
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                        <div className='broc-product-boc'>
                        <figure><img className="img-fluid" src="/img/shield.svg" alt="blog" /><h4><span>rent</span>shield</h4></figure>
                        <div className='broc-product-text'>
                        <h3>Embedded Protection When Needed</h3>
                        <p>Choose flexible insurance coverages and roadside assistance that turns on when the car goes out.</p>
                        </div>
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                        <div className='broc-product-boc'>
                        <figure><img className="img-fluid" src="/img/id.svg" alt="blog" /><h4><span>rent</span>id</h4></figure>
                        <div className='broc-product-text'>
                        <h3>Verify Every Guest, Instantly</h3>
                        <p>Screen renters in seconds with ID, license, insurance checks and renter scoring. </p>
                        </div>
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                        <div className='broc-product-boc'>
                        <figure><img className="img-fluid" src="/img/ai.svg" alt="blog" /><h4><span>rent</span>ai</h4></figure>
                        <div className='broc-product-text'>
                        <h3>AI Rental Task Agent</h3>
                        <p>AI rental agent that completes tasks, solves problems, & gets things done for your business.</p>
                        </div>
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                        <div className='broc-product-boc'>
                        <figure><img className="img-fluid" src="/img/success.svg" alt="blog" /><h4><span>rent</span>success</h4></figure>
                        <div className='broc-product-text'>
                        <h3>Built-In Support & Resolution Center</h3>
                        <p>Dedicated support, real-time rental resolutions, and a focus on lasting customer loyalty.</p>
                        </div>
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                        <div className='broc-product-boc'>
                        <figure><img className="img-fluid" src="/img/academy.svg" alt="blog" /><h4><span>rent</span>academy</h4></figure>
                        <div className='broc-product-text'>
                        <h3>On Demand Industry Education </h3>
                        <p>Where experts drop knowledge & growth strategies on podcasts, articles, and video series,</p>
                        </div>
                        </div>
                    </div>
                    
                    </div>
                  </div>

                  <div className='broch-tools'>
                  <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12'>
                        <h2>Automated Workflows & Tools</h2>
                        <p>Optimizing your business to unlock more time and performance</p>
                    </div>
                   </div>
                   <div className='row justify-content-center broch-tools-list'>

                   <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <h3>Operational </h3>
                    <ul>
  <li>
    <img src="/img/feature-oper-nine.svg" alt="icon" />
    <a href="/rentdirect#SmartBookingManagement">Smart Booking Management</a>
  </li>
  <li>
    <img src="/img/feature-oper-eight.svg" alt="icon" />
    <a href="/rentshield#GuestProtectionPlans">Guest Protection Plans</a>
  </li>
  <li>
    <img src="/img/feature-oper-seven.svg" alt="icon" />
    <a href="/rentdirect#marketing_main">Guest Quotes</a>
  </li>
  <li>
    <img src="/img/feature-oper-six.svg" alt="icon" />
    <a href="/rentdirect#tabMarketing_2">Discount Codes</a>
  </li>
  <li>
    <img src="/img/feature-oper-five.svg" alt="icon" />
    <a href="/rentdirect#tabMarketing_3">Promotional Spotlight</a>
  </li>
  <li>
    <img src="/img/feature-oper-four.svg" alt="icon" />
    <a href="/rentdirect#fleettab1">Booking Calendar</a>
  </li>
  <li>
    <img src="/img/feature-oper-three.svg" alt="icon" />
    <a href="/rentsuccess#onRentGuidelines_2">Direct Communication</a>
  </li>
  <li>
    <img src="/img/feature-oper-two.svg" alt="icon" />
    <a href="/rentdirect#fleettab3">Vehicle Profile</a>
  </li>
  <li>
    <img src="/img/feature-oper-one.svg" alt="icon" />
    <a href="/rentsuccess#rentalSupportAgent">Rental Support Agent</a>
  </li>
</ul>
                    </div>

                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <h3>Logistical </h3>
                    <ul>
  <li>
    <img src="/img/feature-logist-icon-one.svg" alt="icon" />
    <a href="/rentdirect#fleettab2">Fleet Management</a>
  </li>
  <li>
    <img src="/img/feature-logist-icon-two.svg" alt="icon" />
    <a href="/primary-commericial#onRentMain">On-Rent Coverage</a>
  </li>
  <li>
    <img src="/img/feature-logist-icon-three.svg" alt="icon" />
    <a href="/primary-commericial#offRentInsuranceMain">Off-Rent Coverage</a>
  </li>
  <li>
    <img src="/img/feature-logist-icon-four.svg" alt="icon" />
    <a href="/rentdirect#fleettab4">Telematics</a>
  </li>
  <li>
    <img src="/img/feature-logist-icon-six.svg" alt="icon" />
    <a href="/rentshield#NationalRoadsideAssistance">National Roadside Assistance</a>
  </li>
  <li>
    <img src="/img/feature-logist-icon-seven.svg" alt="icon" />
    <a href="/rentsuccess#tolls_and_tickets">Tolls &amp; Tickets</a>
  </li>
  <li>
    <img src="/img/feature-logist-icon-nine.svg" alt="icon" />
    <a href="/rentshield#PersonalRental">Personal/ Leisure Rental</a>
  </li>
  <li>
    <img src="/img/feature-logist-icon-eight.svg" alt="icon" />
    <a href="/rentshield#GigRental">Gig Rental</a>
  </li>
</ul>
                    </div>

                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <h3>Administrative </h3>
                    <ul>
  <li>
    <img src="/img/feature-admin-two.svg" alt="icon" />
    <a href="/rent-id#guestverification">Realtime Guest Verification</a>
  </li>
  <li>
    <img src="/img/feature-admin-one.svg" alt="icon" />
    <a href="/rent-id#AutoInsuranceValidation">Auto Insurance Validation</a>
  </li>
  <li>
    <img src="/img/feature-admin-three.svg" alt="icon" />
    <a href="/rent-id#DriverIQScore">DriverIQ Score</a>
  </li>
  <li>
    <img src="/img/feature-admin-four.svg" alt="icon" />
    <a href="/rentdirect#customerRelationship_1">Review Management</a>
  </li>
  <li>
    <img src="/img/feature-admin-five.svg" alt="icon" />
    <a href="/rentdirect#customerRelationship_3">Schedule Messages</a>
  </li>
  <li>
    <img src="/img/feature-admin-six.svg" alt="icon" />
    <a href="/rentshield#CoverageSettings">Coverage Settings</a>
  </li>
  <li>
    <img src="/img/feature-admin-seven.svg" alt="icon" />
    <a href="/rentdirect#financialManagements_1">Dynamic Invoices</a>
  </li>
  <li>
    <img src="/img/feature-admin-eight.svg" alt="icon" />
    <a href="/rentdirect#financialManagements_2">Dynamic Agreement</a>
  </li>
</ul>
                    </div>

                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <h3>Back Office </h3>
                    <ul>
  <li>
    <img src="/img/feature-office-icon-one.svg" alt="icon" />
    <a href="/rentsuccess#refundpolicy">Refund Process</a>
  </li>
  <li>
    <img src="/img/feature-office-icon-two.svg" alt="icon" />
    <a href="/rentsuccess#violations">Renter Violations</a>
  </li>
  <li>
    <img src="/img/feature-office-icon-three.svg" alt="icon" />
    <a href="/rentsuccess#insurance_claims">Insurance Claims</a>
  </li>
  <li>
    <img src="/img/feature-office-icon-four.svg" alt="icon" />
    <a href="/rentsuccess#guest_behaviors">Report Guests</a>
  </li>
  <li>
    <img src="/img/feature-office-icon-five.svg" alt="icon" />
    <a href="/rentdirect#financialManagements_3">Payment Methods</a>
  </li>
  <li>
    <img src="/img/feature-office-icon-six.svg" alt="icon" />
    <a href="/rentshield#DigitalClaimsManagement">Digital Claims Management</a>
  </li>
  <li>
    <img src="/img/feature-office-icon-seven.svg" alt="icon" />
    <a href="/rentdirect#AnalyticsReporting">Analytics &amp; Reporting</a>
  </li>
  <li>
    <img src="/img/feature-office-icon-eight.svg" alt="icon" />
    <a href="/rent-id#NationalBlockListDatabase">National BlockList Database</a>
  </li>
  <li>
    <img src="/img/feature-office-icon-nine.svg" alt="icon" />
    <a href="/rentsuccess#CancellationPolicies">Cancellation Policy</a>
  </li>
</ul>
                    </div>

                    </div>
                  </div>

                  <div className='broch-business'>
                  <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12'>
                        <h2>Technologies For Your Business</h2>
                        <p>Inovation intended to accelerate growth</p>
                    </div>
                   </div>

                      <div className='row'>
                          <div className='col-lg-12 col-md-12 col-sm-12 business-box'>
                              <div className='row align-items-center'>
                                  <div className='col-lg-6 col-md-6 col-sm-12 business-box-left'>
                                      <img src="img/platformimg.webp" alt="Technologies For Your Business" />
                                  </div>
                                  <div className='col-lg-6 col-md-6 col-sm-12 business-box-right'>
                                      <h3><img src="/img/Technology/platform_icon.svg" alt="icon"/>Rental Platform</h3>
                                      <p>We've embedded everything you need, all in one place. <b>Start for FREE and only pay when you get rented.</b> <span>#GetRentid</span></p>
                                  </div>
                              </div>
                          </div>

                          <div className='col-lg-12 col-md-12 col-sm-12 business-box'>
                              <div className='row align-items-center'>
                                  <div className='col-lg-6 col-md-6 col-sm-12 business-box-left'>
                                      <img src="img/marketplaceimg.webp" alt="Car Rental Marketplace" />
                                  </div>
                                  <div className='col-lg-6 col-md-6 col-sm-12 business-box-right'>
                                      <h3><img src="/img/Technology/map_icon.svg" alt="icon"/>Car Rental Marketplace</h3>
                                      <p>The only ethical & commission-free car rental marketplace. Purpose-built to give rental operators full control of their brand, guest experience, and revenue.</p>
                                  </div>
                              </div>
                          </div>

                          <div className='col-lg-12 col-md-12 col-sm-12 business-box'>
                              <div className='row align-items-center'>
                                  <div className='col-lg-6 col-md-6 col-sm-12 business-box-left'>
                                      <img src="/img/solutionimg.webp" alt="Enterprise Solutions" />
                                  </div>
                                  <div className='col-lg-6 col-md-6 col-sm-12 business-box-right'>
                                      <h3><img src="/img/Technology/api_icon.svg" alt="icon"/>Enterprise Solutions</h3>
                                      <p>Plug-and-Play integrations to build a scalable car rental ecosystem for any organization.</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div className='brochure-contact'>
                      <div className='row align-items-center'>
                          <div className='col-lg-4 col-md-4 col-sm-12 broc-list'>
                              <a href="/rentid.io/"><img src="/img/rlogo.jpg" alt="rent id" />www.rentid.co</a>
                          </div>
                          <div className='col-lg-4 col-md-4 col-sm-12 broc-list'>
                              <a href="#"><img src="/img/emailico.jpg" alt="rent id" />info@rentid.io</a>
                          </div>
                          <div className='col-lg-4 col-md-4 col-sm-12 broc-list'>
                              <a href="#"><img src="/img/phoneico.jpg" alt="rent id" />866-941-2703</a>
                          </div>
                      </div>
                  </div>



                </div>


                   <div className='booth-btn'>
                            <Button onClick={handleClose}>Close</Button>
                            <button className='map_down'>Download map image</button>
                            </div>




                </div>
                </Modal>

                
    </div>
  )
}

export default BrochurePopup
